module.exports = __webpack_public_path__ + "img/export-animation.fedc3fa8.png";